import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasCreatorAccess } from "../utils/roleUtils";

export default function CreatorOnly({ children }) {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="page">
        <div className="empty-state-card">
          <h3>Loading...</h3>
          <p className="settings-description">Checking your creator access.</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/welcome?auth=signin" replace />;
  }

  if (!hasCreatorAccess(userProfile)) {
    return <Navigate to="/become-creator" replace />;
  }

  return children;
}